module.exports = __webpack_public_path__ + "static/media/icon-segurosaude.9f8c368e.svg";